const a = '';

export const environment = {
  production: false,
  reports_url: 'https://reports.staging.nuvertos.com/',
  notification_url: "https://notification.staging.nuvertos.com/",
  hospital_url: "https://hospital.staging.nuvertos.com/",
  // hospital_url: a + "https://localhost:1338/",
  print_url: 'https://print.staging.nuvertos.com/',
  auth_uri: a + "https://directory.staging.nuvertos.com/",
  patient_uri: a + "https://patient.staging.nuvertos.com/",
  filemgr_url: a + "https://files.staging.nuvertos.com/",
  billing_url: a + "https://billing.staging.nuvertos.com/",
  // billing_url: a + "https://billing-v2.staging.nuvertos.com/",
  
  prescription_url: a + "https://prescription.staging.nuvertos.com/",
  appointment_url: a + "https://appointment.staging.nuvertos.com/",
  pharmacy_url: a + "https://pharmacy.staging.nuvertos.com/",
  // pharmacy_url: 'https://docweb-pharmacy.azurewebsites.net/',
  radio_url: a + "https://radiology.staging.nuvertos.com/",
  // radio_url: a + "https://localhost:1401/",
  lab_url: a + "https://lims.staging.nuvertos.com/",
  tpa_url: a + "https://tpa.staging.nuvertos.com/",
  his_ui: "app/patients"
};